export default "__VITE_ASSET__CLeOmPzy__"